import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const chatChannelKeys = new QueryKeyFactory(['chat', 'channel'])
export const chatMessageKeys = new QueryKeyFactory(['chat', 'message'])
